module.exports = "/assets/data/114bf55f4fb05aa7bd8e91ff30cd0d3a-LA22.data.json";